import { create } from 'zustand';
import { TextBlockData, TextSimpleData } from '../dto/EntityRepository';

/** 현재 열려 있는 Text의 TextBlock만 남긴다. 다른 Text에서 고른 선택은 제외한다. */
export const textBlockIdsInCurrentText = (
  selectedSubIdList: string[],
  simpleSubList: { id: string }[],
): string[] => {
  const currentTextBlockIds = new Set(simpleSubList.map((block) => block.id));
  return selectedSubIdList.filter((id) => currentTextBlockIds.has(id));
};

interface ImportStationTextState {
  selectedId: string;
  setSelectedId: (selectedId: string) => void;
  selectedSubIdList: string[];
  addSelectedSubId: (subId: string) => void;
  removeSelectedSubId: (subId: string) => void;
  clearSelectedSubIdList: () => void;
  simpleList: TextSimpleData[];
  simpleSubList: TextBlockData[];
  setSimpleList: (simpleList: TextSimpleData[]) => void;
  setSimpleSubList: (simpleSubList: TextBlockData[]) => void;
  clearSimpleSubList: () => void;
  clearSimpleList: () => void;
}

export const useImportStationTextStore = create<ImportStationTextState>((set) => ({
  selectedId: "",
  setSelectedId: (selectedId: string) => {
    set(() => ({
      selectedId,
    }));
  },
  selectedSubIdList: [],
  addSelectedSubId: (subId: string) => {
    set((state) => {
      const sameTextIds = textBlockIdsInCurrentText(state.selectedSubIdList, state.simpleSubList);
      return {
        selectedSubIdList: sameTextIds.includes(subId) ? sameTextIds : [...sameTextIds, subId],
      };
    });
  },
  removeSelectedSubId: (subId: string) => {
    set((state) => ({
      selectedSubIdList: state.selectedSubIdList.filter((id) => id !== subId),
    }));
  },
  clearSelectedSubIdList: () => {
    set({ selectedSubIdList: [] });
  },
  simpleList: [],
  simpleSubList: [],
  setSimpleList: (simpleList: TextSimpleData[]) => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleList,
      simpleSubList: [],
    }));
  },
  setSimpleSubList: (simpleSubList: TextBlockData[]) => {
    set(() => ({
      simpleSubList,
    }));
  },
  clearSimpleSubList: () => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleSubList: [],
    }));
  },
  clearSimpleList: () => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleList: [],
      simpleSubList: [],
    }));
  },
}));